export default "__VITE_ASSET__LbNjBp2m__"